define('plugin/metricool/MetricoolPlugin',['require','lib/plugin/PluginAbstract','cookieblock'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var CookieBlock = require('cookieblock');

    /**
     * Cookie banner for the Metricool page view tracker of the layout (Social & Ads add-on, main.phtml),
     * which sends nothing until the visitor accepted all cookies
     */
    return PluginAbstract.extend({

        initialize: function () {
            // no tracker (add-on is off) or cookies allowed (or the company hid the banner)
            if (typeof window.sbMetricoolTrack !== 'function' || window.allowCookies) {
                return;
            }

            CookieBlock.addAcceptedHandler(function () {
                // the page the visitor accepted cookies on
                window.sbMetricoolTrack();
            });

            //NB defer showing cookie block until page (and cookie block in particular) is rendered
            setTimeout(function () {
                CookieBlock.show();
            });
        }

    });

});

